import React, { PureComponent } from 'react';
import cx from 'classnames';


class GridImages extends PureComponent {
  state = {
    images: [
      'http://lorempixel.com/228/228/?0',
      'http://lorempixel.com/228/228/?1',
      'http://lorempixel.com/228/228/?2',
      'http://lorempixel.com/228/228/?3',
      'http://lorempixel.com/228/228/?4',
      'http://lorempixel.com/228/228/?5',
      'http://lorempixel.com/228/228/?6',
      'http://lorempixel.com/228/228/?7',
      'http://lorempixel.com/228/228/?8',
      'http://lorempixel.com/228/228/?9'
    ]
  };

  render() {
    const { images } = this.state;
    return (
      <section
        className={
          cx({
            'grid-images': true,
          })
        }>
        {
          images.map((path, index)=> {
            return (<img className={
              cx({
                'grid-images__image': true,
              })
            } key={index} src={path} alt={'grid-image-' + index}/>);
          })
        }
      </section>
    );
  }
}

GridImages.propTypes = {};
GridImages.defaultProps = {};

export default GridImages;



// WEBPACK FOOTER //
// ./src/components/gridImages/GridImages.js